module.exports = __webpack_public_path__ + "static/img/register_ip.4e03df02.gif";